import Cookies from 'universal-cookie';

class Auth {
    constructor() {
        this.cookies = new Cookies();
    }

    getItemFromCookies(name) {
        return this.cookies.get(name);
    }

    setValueToCookies(name, value) {
        this.cookies.set(name, value, { path: '/' });
    }

    removeItemFromCookies(name) {
        this.cookies.remove(name, { path: '/' });
    }

    setItemToStorage(key, value) {
        return localStorage.setItem(key, value);
    }

    getItemFromStorage(key) {
        return localStorage.getItem(key);
    }

    removeItemFromStorage(key) {
        return localStorage.removeItem(key);
    }

    setItemToSession(key, value) {
        return sessionStorage.setItem(key, value);
    }

    getItemFromSession(key) {
        return sessionStorage.getItem(key);
    }

    removeItemFromSession(key) {
        return sessionStorage.removeItem(key);
    }
}

export default Auth;